import React, { useEffect } from "react";
import PageTitle from "../../../components/Common/PageTitle/index";

import {
  PAGE_TITLE,
  PAGE_TEXT,
  INTRO_TEXT,
  CTA_TEXT,
  FORM_SECTION_TITLE,
  FORM_EMBED_SCRIPT_URL,
  FORM_EMBED,
  AMBASSADOR_DATA,
} from "./AmbassadorForm.constants";
import {
  RootBox,
  IntroSection,
  IntroTypography,
  BenefitItemBox,
  BulletTypography,
  BenefitTextTypography,
  CtaSection,
  CtaTypography,
  FormSection,
  FormTitleTypography,
  FormIframe,
} from "./AmbassadorForm.styles";

const useFormEmbedScript = (scriptUrl) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = scriptUrl;
    script.async = true;
    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, [scriptUrl]);
};

const AmbassadorForm = () => {
  useFormEmbedScript(FORM_EMBED_SCRIPT_URL);

  return (
    <RootBox>
      <PageTitle noIcon text={PAGE_TEXT} title={PAGE_TITLE} />

      <IntroSection>
        <IntroTypography>{INTRO_TEXT}</IntroTypography>
      </IntroSection>

      {AMBASSADOR_DATA.map((item) => (
        <BenefitItemBox key={item.id}>
          <BulletTypography component="span">•</BulletTypography>
          <BenefitTextTypography
            component="div"
            dangerouslySetInnerHTML={{ __html: item.text }}
          />
        </BenefitItemBox>
      ))}

      <CtaSection>
        <CtaTypography>{CTA_TEXT}</CtaTypography>
      </CtaSection>

      <FormSection>
        <FormTitleTypography>{FORM_SECTION_TITLE}</FormTitleTypography>
        <FormIframe
          src={FORM_EMBED.src}
          height={FORM_EMBED.height}
          id={`inline-${FORM_EMBED.formId}`}
          data-layout={FORM_EMBED.dataLayout}
          data-trigger-type="alwaysShow"
          data-trigger-value=""
          data-activation-type="alwaysActivated"
          data-activation-value=""
          data-deactivation-type="neverDeactivate"
          data-deactivation-value=""
          data-form-name={FORM_EMBED.title}
          data-layout-iframe-id={`inline-${FORM_EMBED.formId}`}
          data-form-id={FORM_EMBED.formId}
          title={FORM_EMBED.title}
        />
      </FormSection>
    </RootBox>
  );
};

export default AmbassadorForm;
